import { useState } from 'react';
import { ViewContainer } from '@web/components/ui/view-container'; // <-- New container

import { ProcedureDetailsView } from './details/procedures-details-view';
import { ProceduresTable } from './list/procedures-table';

import { Route } from '..';
import { Filter } from '@web/components/ui/view-filters';
import { trpc } from '@web/lib/trpc';

export function ProcedureInterface() {
  const navigate = Route.useNavigate();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [selectedProcedureId, setSelectedProcedureId] = useState<string | null>(
    null,
  );

  const { displayName } = Route.useSearch();

  const { data: proceduresData, refetch: refetchProceduresData } =
    trpc.procedure.listAllWithPagination.useQuery({
      page,
      pageSize,
      displayName,
    });

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPage(1);
  };

  const filters = [
    {
      key: 'displayName',
      label: 'Name',
      type: 'string',
      value: displayName,
      isMainFilter: true,
    },
  ] as const satisfies Filter[];

  const onFilterChange = (
    newSearch: Record<string, string | number | boolean | object | undefined>,
  ) => {
    void navigate({
      search: (current) => ({ ...current, ...newSearch }),
    });
  };

  // Main content: procedures exist
  return (
    <div>
      <ViewContainer
        title="Procedures"
        filters={filters}
        onFilterChange={onFilterChange}
      >
        {/* Your table or any other content goes here */}
        <ProceduresTable
          procedures={proceduresData?.procedures}
          onDetails={({ id }) => {
            setSelectedProcedureId(id);
          }}
          pagination={{
            currentPage: page,
            totalPages: proceduresData?.totalPages ?? 1,
            totalItems: proceduresData?.total ?? 0,
            pageSize,
            onPageChange: handlePageChange,
            onPageSizeChange: handlePageSizeChange,
          }}
        />
      </ViewContainer>

      {/* Dialog for creating/editing procedures */}
      {selectedProcedureId !== null && (
        <ProcedureDetailsView
          procedureId={selectedProcedureId}
          onClose={() => {
            setSelectedProcedureId(null);

            void refetchProceduresData();
          }}
        />
      )}
    </div>
  );
}
